import React from "react";
import { Routes, Route, BrowserRouter as Router, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./view/Home";
import LandingPage from "./view/LandingPage";
import Login from "./view/auth/Login";
import Signup from "./view/auth/Signup";
import "./asset/style/style.css";
import "./asset/style/custome.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { store } from "./store";
import { Provider } from "react-redux";
import DashboardLayout from "./components/Layout/DashboardLayout";
import { PrivateRoute, PublicRoute, GuestOnlyRoute } from "./utils/function";
import ForgotPassword from "./view/auth/ForgotPassword";
import ResetPassword from "./view/auth/ResetPassword";
import LandingShell from "./components/Layout/LandingShell";
import ApiDocsPublic from "./view/ApiDocsPublic";
import Dashboard from "./view/dashboard";
import FuelType from "./view/fuelType";
import LerCatalog from "./view/lerCatalog";
import PartType from "./view/PartType";
import Lots from "./view/Lots";
import LotDetails from "./view/Lots/LotDetails";
import SuppliersTP from "./view/SuppliersTP";
import PartLocation from "./view/partLocation";
import PartGroup from "./view/partGroup";
import PartSides from "./view/partSides";
import Profile from "./view/profile";
import ProfileSecurity from "./view/profile/Security";
import ProfileNotifications from "./view/profile/Notifications";
import ProfileNotificationsHistory from "./view/profile/NotificationsHistory";
import PartCatalog from "./view/partCatalog";
import AddCatalog from "./view/partCatalog/AddCatalog";
import Subscription from "./view/subscription";
import AccountBlocked from "./view/AccountBlocked";
import VehicleCategory from "./view/vehicleCategory";
import VehicleType from "./view/vehicleType";
import VehicleModel from "./view/vehicleModel";
import Vehicle from "./view/vehicle";
import PartsInventory from "./view/PartsInventory";

import VehicleProcess from "./view/vehicleProcess";
import AddParts from "./view/PartsInventory/AddParts";
import AddForParts from "./view/PartsInventory/AddForParts";
import RolePermission from "./view/RolePermission/Roles";
import AddRolePermission from "./view/RolePermission/AddRolePermission";

import User from "./view/user";
import TermsCondition from "./view/TermsCondition";
import PrivacyPolicy from "./view/privacyPolicy";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FAQ from "./view/FAQ";
import Settings from "./view/settings";
import FaqAdmin from "./view/FaqAdmin";
import TermsConditionAdmin from "./view/TermsConditionAdmin";
import PrivacyPolicyAdmin from "./view/privacyPolicyAdmin";
import DepollutionOpration from "./view/DepollutionOpration";
import AddForVehicleDepollution from "./view/DepollutionOpration/AddForVehicleDepollution";
import AddOtherDepollution from "./view/DepollutionOpration/AddOtherDepollution";
import Park from "./view/park";
import Shelf from "./view/shelf";
import Certificate from "./view/certificate";
import WarehouseEntityType from "./view/WarehouseEntityType";
import WareHouseMain from "./view/WareHouse";
import PartInventoryDetails from "./view/PartsInventory/PartInventoryDetails";
import LabelTemplates from "./view/labelTemplates";
import LabelTemplateEditor from "./view/labelTemplates/Editor";
import PartBrand from "./view/PartBrand";
import VehicleMake from "./view/vehicleMake";
import VehicleEngine from "./view/vehicleEngine";
import VehicleVariants from "./view/vehicleVariants";
import VehicleDetails from "./view/vehicle/VehicleDetails";
import PartDetailsVehicle from "./view/vehicle/PartDetailsVehicle";
import PartDetailsPublic from "./view/vehicle/PartDetailsPublic";
import PartVehicledetails from "./view/PartsInventory/PartVehicledetails";
import PartdetailsInventory from "./view/PartsInventory/PartdetailsInventory";
import Dismantle from "./view/dismantle/Dismantle";
import AddDistmental from "./view/dismantle/AddDistmental";
import CompanyEcommerceHash from "./view/CompanyEcommerceHash";
import APIDocumentation from "./view/API Documentation";
import MainPartDetails from "./view/PartsInventory/MainPartDetails";
import PartExportPdfList from "./view/PartsInventory/PartExportPdfList";
import Sales from "./view/sales";
import EcommarceCompany from "./view/EcommarceCompany";
import Refund from "./view/refund";
import SalesDetails from "./view/sales/salesDetails";
import PartLocationAssign from "./view/PartLocationAssign";
import AssociateLocationPart from "./view/PartLocationAssign/AssociateLocationPart";
import AssociateMultiPart from "./view/PartLocationAssign/AssociateMultiPart";

import CompanySubscribeNewsLetter from "./view/CompanySubscribeNewsLetter";
import WareHouseType from "./view/WareHouseType";
import ClientProfile from "./view/ClientProfile";
import Categories from "./view/Categories";
import SubCategories from "./view/SubCategories.js";
import ContactType from "./view/ContactType/index.js";
import ActionType from "./view/ActionType/index.js";
import Reserves from "./view/Reserves/index.js";
import ReservesPendingList from "./view/Reserves/ReservesPendingList.js";
import ChangeLocationPart from "./view/PartLocationAssign/ChangeLocationPart.js";
import AddReserves from "./view/Reserves/AddReserves.js";
import ReservesList from "./view/Reserves/ReservesList.js";
import CreateReserves from "./view/Reserves/CreateReserves.js";
import AddResClient from "./view/Reserves/AddResClient.js";
import InternalSales from "./view/InternalSales/index.js";
import Task from "./view/Task/index.js";
import AddTask from "./view/Task/AddTask.js";
import TaskReport from "./view/TaskReport/index.js";
import SwapPart from "./view/partCatalog/SwapPart.js";
import RepairPart from "./view/RepairPart/index.js";
import HistoryRepair from "./view/HistoryRepair/index.js";
import AutofillParts from "./view/PartsInventory/AutofillParts.js";
import AddForLotParts from "./view/PartsInventory/AddForLotParts.js";
import Moloni from "./view/moloni/index.js";
import MaloniToken from "./view/moloni/MaloniToken.js";
import MoloniSettings from "./view/moloni/MoloniSettings.js";
import BankAccount from "./view/moloni/BankAccount.js";
import CaeCodes from "./view/moloni/CaeCodes.js";
import PaymentMethod from "./view/moloni/PaymentMethod.js";
import MaturityDates from "./view/moloni/MaturityDates.js";
import DeliveryMethods from "./view/moloni/DeliveryMethods.js";
import VehiclesMoloni from "./view/moloni/VehiclesMoloni.js";
import Deduction from "./view/moloni/Deduction.js";
import TaxMoloni from "./view/moloni/TaxMoloni.js";
import MeasurementUnits from "./view/moloni/MeasurementUnits.js";
import IdentificationTemplates from "./view/moloni/IdentificationTemplates.js";
import Document from "./view/moloni/Document.js";
import WarehouseMoloni from "./view/moloni/WarehouseMoloni.js";
import ProductMoloni from "./view/moloni/ProductMoloni.js";
import ProductMainMoloni from "./view/moloni/ProductMainMoloni.js";
import MoloniProduct from "./view/moloni/MoloniProduct.js";
import ProductCategories from "./view/moloni/ProductCategories.js";
import ProductPriceMoloni from "./view/moloni/ProductPriceMoloni.js";
import MoloniEntities from "./view/moloni/MoloniEntities.js";
import SalesMen from "./view/moloni/SalesMen.js";
import SupplierMoloni from "./view/moloni/SupplierMoloni.js";
import CustomerMoloni from "./view/moloni/CustomerMoloni.js";
import MoloniDocument from "./view/moloni/MoloniDocument.js";
import MoloniInvoice from "./view/moloni/MoloniInvoice.js";
import VisualGestLanding from "./view/olifel/index.js";
import VisualGestInvoice from "./view/olifel/VisualGestInvoice.js";
import VisualGestStockAlerts from "./view/olifel/VisualGestStockAlerts.js";
import VisualGestOperationLog from "./view/olifel/VisualGestOperationLog.js";
import WizardMigrate from "./view/wizardMigrate/index.js";
import WizardMigrateList from "./view/wizardMigrate/WizardMigrateList.js";
import AddProductMoloni from "./view/moloni/AddProductMainMoloni.js";
import MoloniSubDocument from "./view/moloni/MoloniSubDocument.js";
import AddInvoice from "./view/moloni/AddInvoice.js";
import MoloniCurrency from "./view/moloni/MoloniCurrency.js";
import MoloniReceipt from "./view/moloni/MoloniReceipt.js";
import AddReceipt from "./view/moloni/AddReceipt.js";
import MoloniCreditNote from "./view/moloni/MoloniCreditNote.js";
import AddCreditNote from "./view/moloni/AddCreditNote.js";
import MoloniDebitNote from "./view/moloni/MoloniDebitNote.js";
import AddDebitNote from "./view/moloni/AddDebitNote.js";
import MoloniSimplifiedInvoices from "./view/moloni/MoloniSimplifiedInvoices.js";
import AddSimplifiedInvoices from "./view/moloni/AddSimplifiedInvoices.js";
import MoloniDeliveriyNote from "./view/moloni/MoloniDeliveriyNote.js";
import AddDeliveryNote from "./view/moloni/AddDeliveryNote.js";
import AddBillLanding from "./view/moloni/AddBillLanding.js";
import PartsInvenPhoto from "./view/PartsInventory/PartsInvenPhoto.js";
import MoloniOwnAssetsMovement from "./view/moloni/MoloniOwnAssetsMovement.js";
import AddOwnAssetsMovement from "./view/moloni/AddOwnAssetsMovement.js";
import MoloniWaybills from "./view/moloni/MoloniWaybills.js";
import AddWaybills from "./view/moloni/AddWaybills.js";
import AddCustomerReturnNotes from "./view/moloni/AddCustomerReturnNotes.js";
import MoloniCustomerReturnNotes from "./view/moloni/MoloniCustomerReturnNotes.js";
import AddEstimate from "./view/moloni/AddEstimate.js";
import MoloniEstimate from "./view/moloni/MoloniEstimate.js";
import AddInternalDocuments from "./view/moloni/AddInternalDocuments.js";
import MoloniInternalDocuments from "./view/moloni/MoloniInternalDocuments.js";
import AddInvoiceReceipts from "./view/moloni/AddInvoiceReceipts.js";
import MoloniInvoiceReceipts from "./view/moloni/MoloniInvoiceReceipts.js";
import AddPaymentReturns from "./view/moloni/AddPaymentReturns.js";
import MoloniPaymentReturns from "./view/moloni/MoloniPaymentReturns.js";
import MoloniPurchaseOrder from "./view/moloni/MoloniPurchaseOrder.js";
import AddPurchaseOrder from "./view/moloni/AddPurchaseOrder.js";
import MoloniSupplierPurchaseOrder from "./view/moloni/MoloniSupplierPurchaseOrder.js";
import AddSupplierPurchaseOrder from "./view/moloni/AddSupplierPurchaseOrder.js";
import AddSupplierInvoices from "./view/moloni/AddSupplierInvoices.js";
import MoloniSupplierInvoices from "./view/moloni/MoloniSupplierInvoices.js";
import MoloniSupplierSimplifiedInvoices from "./view/moloni/MoloniSupplierSimplifiedInvoices.js";
import AddSupplierSimplifiedInvoices from "./view/moloni/AddSupplierSimplifiedInvoices.js";
import AddSupplierCreditNotes from "./view/moloni/AddSupplierCreditNotes.js";
import MoloniSupplierCreditNotes from "./view/moloni/MoloniSupplierCreditNotes.js";
import MoloniSupplierDebit from "./view/moloni/MoloniSupplierDebit.js";
import AddSupplierDebit from "./view/moloni/AddSupplierDebit.js";
import AddSupplierReturnNotes from "./view/moloni/AddSupplierReturnNotes.js";
import MoloniSupplierReturnNote from "./view/moloni/MoloniSupplierReturnNote.js";
import AddSupplierReceipts from "./view/moloni/AddSupplierReceipts.js";
import MoloniSupplierReceipts from "./view/moloni/MoloniSupplierReceipts.js";
import AddSupplierWarrantyRequests from "./view/moloni/AddSupplierWarrantyRequests.js";
import MoloniSupplierWarrantyRequest from "./view/moloni/MoloniSupplierWarrantyRequest.js";
import MoloniGlobalGuides from "./view/moloni/MoloniGlobalGuides.js";
import AddGlobalGuides from "./view/moloni/AddGlobalGuides.js";
import MoloniBillsOfLading from "./view/moloni/MoloniBillsOfLading.js";
import VehiclePartCheck from "./view/vehiclePartCheck/index.js";
import AddVehiclePartCheck from "./view/vehiclePartCheck/AddVehiclePartCheck.js";
import UpdateVehiclePartCheck from "./view/vehiclePartCheck/UpdateVehiclePartCheck.js";
import AddTaxAndFees from "./view/moloni/AddTaxAndFees.js";
import AddIdentificationTemplates from "./view/moloni/AddIdentificationTemplates.js";
import AddWarehouseMoloni from "./view/moloni/AddWarehouseMoloni.js";
import AddCustomerMoloni from "./view/moloni/AddCustomerMoloni.js";
import AddSalesmenMoloni from "./view/moloni/AddSalesmenMoloni.js";
import AddSupplier from "./view/moloni/AddSupplier.js";
import Mapping from "./view/mapping/index.js";
import MoloniEntry from "./view/moloni/MoloniEntry";
import HistoryRepairAllList from "./view/HistoryRepair/historyRepair.js";
import AddInternal from "./view/InternalSales/AddInternal.js";
import AddInvoiceData from "./view/InternalSales/AddInvoiceData.js";
import AcceptedInternal from "./view/InternalSales/AcceptedInternal.js";
import Faturacao from "./view/faturacao/List.js";
import NewFaturacao from "./view/faturacao/New.js";
import ValorcarList from "./view/valorcar/List.js";
import ValorcarReport from "./view/valorcar/Report.js";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          toastClassName="tp-toast"
          progressClassName="tp-toast-progress"
        />
        <Router>
          <Routes>
            <Route element={<GuestOnlyRoute />}>
              <Route path="/" element={<LandingPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
            </Route>
            <Route path="/reset-password/:token" element={<ResetPassword />} />

            <Route
              path="/terms-condition"
              element={
                <LandingShell title="Termos e Condições">
                  <TermsCondition />
                </LandingShell>
              }
            />

            <Route
              path="/privacy-policy"
              element={
                <LandingShell title="Política de Privacidade">
                  <PrivacyPolicy />
                </LandingShell>
              }
            />
            <Route
              path="/faq"
              element={
                <LandingShell title="Perguntas Frequentes">
                  <FAQ />
                </LandingShell>
              }
            />
            <Route path="/api-docs" element={<ApiDocsPublic />} />

            <Route
              path="/api-documentation"
              element={
                <Layout>
                  {" "}
                  <APIDocumentation />{" "}
                </Layout>
              }
            />
            <Route path="/moloni-entry" element={<MoloniEntry />} />
            <Route path="/maloni-token" element={<MaloniToken />} />

            <Route path="/part-details/:uuid" element={<PartDetailsPublic />} />
            {/* Página de conta bloqueada — fora do PrivateRoute e sem
                DashboardLayout. Acessível sempre que o axios interceptor
                redirecciona com 402, sem fazer chamadas API que causassem
                loop. */}
            <Route path="/account-blocked" element={<AccountBlocked />} />
            <Route element={<GuestOnlyRoute />}>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
            </Route>

            <Route path="/" element={<PrivateRoute />}>
              <Route path={"/"} element={<DashboardLayout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/fuel-type" element={<FuelType />} />
                <Route path="/part-type" element={<PartType />} />
                <Route path="/lots" element={<Lots />} />
                <Route path="/lot-details/:idOrUuid" element={<LotDetails />} />
                <Route path="/suppliers-tp" element={<SuppliersTP />} />
                <Route path="/part-location" element={<PartLocation />} />
                <Route path="/part-group" element={<PartGroup />} />
                <Route path="/part-sides" element={<PartSides />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/profile/security" element={<ProfileSecurity />} />
                <Route path="/profile/notifications" element={<ProfileNotificationsHistory />} />
                <Route path="/profile/notifications/preferences" element={<ProfileNotifications />} />
                <Route path="/ler-catalog" element={<LerCatalog />} />
                <Route path="/subscription" element={<Subscription />} />
                <Route path="/part-catalog" element={<PartCatalog />} />
                <Route path="/add-part-catalog" element={<AddCatalog />} />
                <Route
                  path="/add-part-catalog/:uuid"
                  element={<AddCatalog />}
                />
                <Route path="/vehicle-category" element={<VehicleCategory />} />
                <Route path="/vehicle-type" element={<VehicleType />} />
                <Route path="/vehicle-model" element={<VehicleModel />} />
                <Route path="/vehicle" element={<Vehicle />} />
                <Route path="/vehicle-process" element={<VehicleProcess />} />
                <Route path="/vehicle/:uuid" element={<Vehicle />} />
                <Route
                  path="/vehicle/details/:uuid"
                  element={<VehicleDetails />}
                />

                <Route
                  path="/part/details/main/:uuid"
                  element={<MainPartDetails />}
                />

                <Route
                  path="/part/export/list"
                  element={<PartExportPdfList />}
                />

                <Route
                  path="/vehicle/details/part/:uuid"
                  element={<PartVehicledetails />}
                />

                <Route
                  path="/part/details/inven/:uuid"
                  element={<PartdetailsInventory />}
                />

                <Route path="/parts-inventory" element={<PartsInventory />} />
                <Route path="/auto-fill-parts" element={<AutofillParts />} />
                <Route
                  path="/parts-inventory/AddParts"
                  element={<AddParts />}
                />
                <Route
                  path="/parts-inventory/AddParts/:uuid"
                  element={<AddParts />}
                />
                <Route
                  path="/parts-inventory-addparts"
                  element={<AddForParts />}
                />
                <Route
                  path="/parts-inventory/add-for-lot"
                  element={<AddForLotParts />}
                />
                <Route
                  path="/parts-inventory/details/:uuid"
                  element={<PartInventoryDetails />}
                />

                <Route path="/Roles" element={<RolePermission />} />
                <Route
                  path="/add-role-permssion"
                  element={<AddRolePermission />}
                />
                <Route
                  path="/add-role-permssion/:uuid"
                  element={<AddRolePermission />}
                />

                <Route
                  path="/part-details-vehicle/:uuid"
                  element={<PartDetailsVehicle />}
                />

                <Route path="/User" element={<User />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/faqs" element={<FaqAdmin />} />
                <Route
                  path="/terms-condition-admin"
                  element={<TermsConditionAdmin />}
                />
                <Route
                  path="/privacy-policy-admin"
                  element={<PrivacyPolicyAdmin />}
                />
                <Route
                  path="/depollution-operation"
                  element={<DepollutionOpration />}
                />

                <Route
                  path="/add-vehicle-depollution-operation"
                  element={<AddForVehicleDepollution />}
                />

                <Route
                  path="/add-vehicle-depollution-operation/:uuid"
                  element={<AddForVehicleDepollution />}
                />

                <Route
                  path="/other-depollution-operation"
                  element={<AddOtherDepollution />}
                />
                <Route path="/park" element={<Park />} />
                <Route path="/shelf" element={<Shelf />} />
                <Route path="/certificate" element={<Certificate />} />
                <Route path="/label-templates" element={<LabelTemplates />} />
                <Route
                  path="/label-templates/editor/:id"
                  element={<LabelTemplateEditor />}
                />
                {/* Legacy redirects: users with stale menus_data (the menu
                    comes from their JWT and only refreshes on re-login)
                    land on these URLs. Redirect them to the new page. */}
                <Route
                  path="/label"
                  element={<Navigate to="/label-templates" replace />}
                />
                <Route
                  path="/add-label"
                  element={<Navigate to="/label-templates" replace />}
                />
                <Route
                  path="/pool-printing"
                  element={<Navigate to="/label-templates" replace />}
                />

                <Route
                  path="/warehouse-entity-type"
                  element={<WarehouseEntityType />}
                />
                <Route path="/warehouse" element={<WareHouseMain />} />
                <Route path="/brand" element={<PartBrand />} />
                <Route path="/vehicle-make" element={<VehicleMake />} />
                <Route path="/vehicle-engine" element={<VehicleEngine />} />
                <Route path="/vehicle-variants" element={<VehicleVariants />} />
                <Route path="/dismantle" element={<Dismantle />} />
                <Route path="/add-dismental" element={<AddDistmental />} />
                <Route
                  path="/add-dismental/:uuid"
                  element={<AddDistmental />}
                />

                <Route
                  path="/company-ecommerce-hash"
                  element={<CompanyEcommerceHash />}
                />
                <Route path="/sales" element={<Sales />} />
                <Route path="/refund" element={<Refund />} />

                <Route path="/sales-details/:uuid" element={<SalesDetails />} />

                <Route
                  path="/ecommerce-company-lists"
                  element={<EcommarceCompany />}
                />

                <Route
                  path="/part-location-asssign"
                  element={<PartLocationAssign />}
                />

                <Route
                  path="/associate-multi-part"
                  element={<AssociateMultiPart />}
                />

                <Route
                  path="/associate-location-part"
                  element={<AssociateLocationPart />}
                />

                <Route
                  path="/company-subscribe-newsLetter"
                  element={<CompanySubscribeNewsLetter />}
                />

                <Route path="/warehouse-type" element={<WareHouseType />} />
                <Route path="/client-profile" element={<ClientProfile />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/sub-categories" element={<SubCategories />} />
                <Route path="/action-type" element={<ActionType />} />
                <Route path="/contact-type" element={<ContactType />} />
                <Route path="/reserves" element={<Reserves />} />
                <Route path="/reserves" element={<Reserves />} />
                <Route
                  path="/change-location-part"
                  element={<ChangeLocationPart />}
                />

                {/* <Route
                  path="/reserves-pending-list"
                  element={<ReservesPendingList />}
                /> */}
                <Route path="/reserves-list" element={<Reserves />} />
                <Route path="/add-reserves" element={<AddReserves />} />
                <Route path="/add-reserves/:uuid" element={<AddReserves />} />
                <Route path="/add-internal" element={<AddInternal />} />
                <Route path="/show-reserves-list" element={<ReservesList />} />
                <Route path="/create-reserves" element={<AddResClient />} />
                <Route path="/internal-sales" element={<InternalSales />} />
                <Route path="/tasks" element={<Task />} />
                <Route path="/add-tasks" element={<AddTask />} />
                <Route path="/add-tasks/:uuid" element={<AddTask />} />
                <Route path="/task-report" element={<TaskReport />} />
                <Route path="/swap-part" element={<SwapPart />} />
                <Route path="/repairs-parts" element={<RepairPart />} />
                <Route
                  path="/all-repairs-parts/:uuid"
                  element={<HistoryRepairAllList />}
                />
                <Route
                  path="/history-repairs-process"
                  element={<HistoryRepair />}
                />
                <Route path="/moloni" element={<Moloni />} />
                <Route path="/moloni-settings" element={<MoloniSettings />} />
                <Route path="/bankAccounts" element={<BankAccount />} />
                <Route path="/caeCodes" element={<CaeCodes />} />
                <Route path="/paymentMethods" element={<PaymentMethod />} />
                <Route path="/maturityDates" element={<MaturityDates />} />
                <Route path="/deliveryMethods" element={<DeliveryMethods />} />
                <Route path="/vehicles" element={<VehiclesMoloni />} />
                <Route path="/deductions" element={<Deduction />} />
                <Route path="/taxAndFees" element={<TaxMoloni />} />
                <Route
                  path="/measurementUnits"
                  element={<MeasurementUnits />}
                />
                <Route
                  path="/identificationTemplates"
                  element={<IdentificationTemplates />}
                />
                <Route path="/documentSets" element={<Document />} />
                <Route path="/warehouses" element={<WarehouseMoloni />} />
                <Route path="/productProperties" element={<ProductMoloni />} />
                <Route path="/moloni-products" element={<MoloniProduct />} />
                <Route path="/products" element={<ProductMainMoloni />} />
                <Route
                  path="/productsCategories"
                  element={<ProductCategories />}
                />
                <Route path="/priceClasses" element={<ProductPriceMoloni />} />

                <Route path="/moloni-entities" element={<MoloniEntities />} />
                <Route path="/salesmen" element={<SalesMen />} />
                <Route path="/suppliers" element={<SupplierMoloni />} />
                <Route path="/customers" element={<CustomerMoloni />} />
                <Route path="/moloni-document" element={<MoloniDocument />} />
                <Route path="/invoice" element={<MoloniInvoice />} />
                <Route path="/add-invoice" element={<AddInvoice />} />
                <Route path="/add-invoice/:uuid" element={<AddInvoice />} />
                <Route path="/documents" element={<MoloniSubDocument />} />

                {/* VisualGest (Olifel) — Fase O.8 */}
                <Route path="/visualgest" element={<VisualGestLanding />} />
                <Route path="/visualgest-invoices" element={<VisualGestInvoice />} />
                <Route
                  path="/visualgest-stock-alerts"
                  element={<VisualGestStockAlerts />}
                />
                <Route
                  path="/visualgest-operation-log"
                  element={<VisualGestOperationLog />}
                />
                <Route path="/add-moloni" element={<AddProductMoloni />} />
                <Route
                  path="/add-moloni/:uuid"
                  element={<AddProductMoloni />}
                />
                <Route path="/wizard-migrate" element={<WizardMigrate />} />
                <Route
                  path="/wizard-migrate-List"
                  element={<WizardMigrateList />}
                />
                <Route path="/currency" element={<MoloniCurrency />} />
                <Route path="/receipts" element={<MoloniReceipt />} />
                <Route path="/add-receipts" element={<AddReceipt />} />
                <Route path="/add-receipts/:uuid" element={<AddReceipt />} />
                <Route path="/creditNotes" element={<MoloniCreditNote />} />
                <Route path="/add-credit-notes" element={<AddCreditNote />} />
                <Route
                  path="/add-credit-notes/:uuid"
                  element={<AddCreditNote />}
                />
                <Route path="/debitNotes" element={<MoloniDebitNote />} />
                <Route path="/add-debit-notes" element={<AddDebitNote />} />
                <Route
                  path="/add-debit-notes/:uuid"
                  element={<AddDebitNote />}
                />
                <Route
                  path="/simplifiedInvoices"
                  element={<MoloniSimplifiedInvoices />}
                />
                <Route
                  path="/add-simplified-invoices"
                  element={<AddSimplifiedInvoices />}
                />
                <Route
                  path="/add-simplified-invoices/:uuid"
                  element={<AddSimplifiedInvoices />}
                />
                <Route
                  path="/deliveryNotes"
                  element={<MoloniDeliveriyNote />}
                />
                <Route
                  path="/add-delivery-notes"
                  element={<AddDeliveryNote />}
                />
                <Route
                  path="/add-delivery-notes/:uuid"
                  element={<AddDeliveryNote />}
                />
                <Route
                  path="/billsOfLading"
                  element={<MoloniBillsOfLading />}
                />
                <Route
                  path="/add-bills-of-lading"
                  element={<AddBillLanding />}
                />
                <Route
                  path="/update-bills-of-lading/:uuid"
                  element={<AddBillLanding />}
                />
                <Route
                  path="/parts-images/:uuid"
                  element={<PartsInvenPhoto />}
                />
                <Route
                  path="/ownAssetsMovement"
                  element={<MoloniOwnAssetsMovement />}
                />
                <Route
                  path="/ownAssetsMovement"
                  element={<MoloniOwnAssetsMovement />}
                />
                <Route path="/add-own-mg" element={<AddOwnAssetsMovement />} />
                <Route
                  path="/update-own-mg/:uuid"
                  element={<AddOwnAssetsMovement />}
                />
                <Route path="/waybills" element={<MoloniWaybills />} />
                <Route path="/add-way-bills" element={<AddWaybills />} />
                <Route
                  path="/update-way-bills/:uuid"
                  element={<AddWaybills />}
                />

                <Route
                  path="/customerReturnNotes"
                  element={<MoloniCustomerReturnNotes />}
                />
                <Route
                  path="/add-customer-return-note"
                  element={<AddCustomerReturnNotes />}
                />
                <Route
                  path="/update-customer-return-note/:uuid"
                  element={<AddCustomerReturnNotes />}
                />

                <Route path="/estimates" element={<MoloniEstimate />} />
                <Route path="/add-estimates" element={<AddEstimate />} />
                <Route
                  path="/update-estimates/:uuid"
                  element={<AddEstimate />}
                />

                <Route
                  path="/internalDocuments"
                  element={<MoloniInternalDocuments />}
                />
                <Route
                  path="/add-internal-documents"
                  element={<AddInternalDocuments />}
                />
                <Route
                  path="/update-internal-documents/:uuid"
                  element={<AddInternalDocuments />}
                />

                <Route
                  path="/invoiceReceipts"
                  element={<MoloniInvoiceReceipts />}
                />
                <Route
                  path="/add-invoice-receipts"
                  element={<AddInvoiceReceipts />}
                />
                <Route
                  path="/update-invoice-receipts/:uuid"
                  element={<AddInvoiceReceipts />}
                />

                <Route
                  path="/paymentReturns"
                  element={<MoloniPaymentReturns />}
                />
                <Route
                  path="/add-payment-returns"
                  element={<AddPaymentReturns />}
                />
                <Route
                  path="/update-payment-returns/:uuid"
                  element={<AddPaymentReturns />}
                />

                <Route
                  path="/purchaseOrder"
                  element={<MoloniPurchaseOrder />}
                />
                <Route
                  path="/add-purchase-order"
                  element={<AddPurchaseOrder />}
                />
                <Route
                  path="/update-purchase-order/:uuid"
                  element={<AddPurchaseOrder />}
                />

                <Route
                  path="/supplierPurchaseOrder"
                  element={<MoloniSupplierPurchaseOrder />}
                />
                <Route
                  path="/add-supplier-purchase-order"
                  element={<AddSupplierPurchaseOrder />}
                />
                <Route
                  path="/update-supplier-purchase-order/:uuid"
                  element={<AddSupplierPurchaseOrder />}
                />

                <Route
                  path="/supplierInvoices"
                  element={<MoloniSupplierInvoices />}
                />
                <Route
                  path="/add-supplier-invoices"
                  element={<AddSupplierInvoices />}
                />
                <Route
                  path="/update-supplier-invoices/:uuid"
                  element={<AddSupplierInvoices />}
                />

                <Route
                  path="/supplierSimplifiedInvoices"
                  element={<MoloniSupplierSimplifiedInvoices />}
                />
                <Route
                  path="/add-supplier-simplified-invoices"
                  element={<AddSupplierSimplifiedInvoices />}
                />
                <Route
                  path="/update-supplier-simplified-invoices/:uuid"
                  element={<AddSupplierSimplifiedInvoices />}
                />

                <Route
                  path="/supplierCreditNotes"
                  element={<MoloniSupplierCreditNotes />}
                />
                <Route
                  path="/add-supplier-credit-notes"
                  element={<AddSupplierCreditNotes />}
                />
                <Route
                  path="/update-supplier-credit-notes/:uuid"
                  element={<AddSupplierCreditNotes />}
                />

                <Route
                  path="/supplierDebitNotes"
                  element={<MoloniSupplierDebit />}
                />
                <Route
                  path="/add-supplier-debit-notes"
                  element={<AddSupplierDebit />}
                />
                <Route
                  path="/update-supplier-debit-notes/:uuid"
                  element={<AddSupplierDebit />}
                />

                <Route
                  path="/supplierReturnNotes"
                  element={<MoloniSupplierReturnNote />}
                />
                <Route
                  path="/add-supplier-return-notes"
                  element={<AddSupplierReturnNotes />}
                />
                <Route
                  path="/update-supplier-return-notes/:uuid"
                  element={<AddSupplierReturnNotes />}
                />

                <Route
                  path="/supplierReceipts"
                  element={<MoloniSupplierReceipts />}
                />
                <Route
                  path="/add-supplier-receipts"
                  element={<AddSupplierReceipts />}
                />
                <Route
                  path="/update-supplier-receipts/:uuid"
                  element={<AddSupplierReceipts />}
                />

                <Route
                  path="/supplierWarrantyRequests"
                  element={<MoloniSupplierWarrantyRequest />}
                />
                <Route
                  path="/add-supplier-warranty-requests"
                  element={<AddSupplierWarrantyRequests />}
                />
                <Route
                  path="/update-supplier-warranty-requests/:uuid"
                  element={<AddSupplierWarrantyRequests />}
                />

                <Route path="/globalGuides" element={<MoloniGlobalGuides />} />
                <Route
                  path="/add-global-guides"
                  element={<AddGlobalGuides />}
                />
                <Route
                  path="/update-global-guides/:uuid"
                  element={<AddGlobalGuides />}
                />
                <Route
                  path="/check-list-vehicles"
                  element={<VehiclePartCheck />}
                />
                <Route
                  path="/add-check-list-vehicles"
                  element={<AddVehiclePartCheck />}
                />
                <Route
                  path="/update-check-list-vehicles/:uuid"
                  element={<UpdateVehiclePartCheck />}
                />

                <Route path="/add-tax-fees" element={<AddTaxAndFees />} />
                <Route
                  path="/update-tax-fees/:uuid"
                  element={<AddTaxAndFees />}
                />

                <Route
                  path="/add-identification-templates"
                  element={<AddIdentificationTemplates />}
                />
                <Route
                  path="/update-identification-templates/:uuid"
                  element={<AddIdentificationTemplates />}
                />
                <Route
                  path="/add-warehouses"
                  element={<AddWarehouseMoloni />}
                />
                <Route
                  path="/update-warehouses/:uuid"
                  element={<AddWarehouseMoloni />}
                />

                <Route path="/add-customer" element={<AddCustomerMoloni />} />
                <Route
                  path="/update-customer/:uuid"
                  element={<AddCustomerMoloni />}
                />

                <Route path="/add-salesMen" element={<AddSalesmenMoloni />} />
                <Route
                  path="/update-salesMen/:uuid"
                  element={<AddSalesmenMoloni />}
                />

                <Route path="/add-supplier" element={<AddSupplier />} />
                <Route
                  path="/update-supplier/:uuid"
                  element={<AddSupplier />}
                />
                <Route path="/mapping" element={<Mapping />} />
                <Route path="/add-part-invoice" element={<AddInvoiceData />} />
                <Route path="/add-part-invoice-sales" element={<AddInvoiceData />} />
                <Route path="/accept-invoice" element={<AcceptedInternal />} />
                <Route path="/accept-invoice/:uuid" element={<AcceptedInternal />} />
                <Route path="/accept-invoice-sales" element={<AcceptedInternal />} />
                <Route path="/faturacao" element={<Faturacao />} />
                <Route path="/faturacao/nova" element={<NewFaturacao />} />
                <Route
                  path="/faturacao/editar/:documentId"
                  element={<NewFaturacao />}
                />
                <Route path="/valorcar" element={<ValorcarList />} />
                <Route path="/valorcar/relatorios" element={<ValorcarReport />} />
              </Route>
            </Route>
          </Routes>
        </Router>
      </Provider>
    </div>
  );
}

export default App;
